/* eslint max-classes-per-file: 0 */

import {
  Topic as Data,
  TopicCollection as Collection,
} from '@/typings/api/Topic'
import { TopicsApi as Api } from '@/api/resources'

import { Fabric } from '@/store/createCrudModule'
import { MapParams, idTransformer } from '@/store/createCrudModule/TransformerParams'


const { TransformerParams, Adapter } = Fabric<Data, Collection>()

export class TopicsTransformerParams extends TransformerParams {
  protected delete_multiple_param = 'topic_ids';

  public update(payload: MapParams, rawParams: MapParams) {
    const newPay: MapParams = payload
    newPay.children = (newPay.children as Data[]).map((child) => child.id)
    const params = {
      ...newPay,
      ...this.getParamsWithDefaults(rawParams),
    }
    return idTransformer(params, rawParams)
  }

  public create(payload: MapParams, rawParams: MapParams) {
    const newPay: MapParams = payload
    newPay.children = (newPay.children as Data[]).map((child) => child.id)
    const params = {
      ...newPay,
      ...this.getParamsWithDefaults(rawParams),
    }
    return idTransformer(params, rawParams)
  }
}

export class TopicsAdapter extends Adapter<Api> {
  public readonly api = new Api();

  public readonly transformerParams = new TopicsTransformerParams();
}
